import { useLeague } from "@/hooks/useLeague";

const HotLeaguesPanel = () => {
  const {
    hotLeagues,
    selectedLeague,
    isLoadingHot,
    errorHot,
    selectLeague,
  } = useLeague();

  const handleSelectAll = () => {
    selectLeague({ id: 0, name: "Tất cả giải đấu" });
  };

  return (
    <div className="rounded-lg border border-[var(--theme-border)] bg-[var(--theme-bg)] p-3">
      <div className="text-sm font-semibold text-[var(--theme-text)] mb-2">
        Giải đấu hot
      </div>

      {isLoadingHot && (
        <div className="text-xs text-[var(--theme-text-muted)]">
          Đang tải giải đấu...
        </div>
      )}

      {errorHot && (
        <div className="text-xs text-red-500">
          Có lỗi xảy ra: {errorHot}
        </div>
      )}

      {!isLoadingHot && !errorHot && (
        <div className="flex flex-col gap-2">
          <button
            type="button"
            onClick={handleSelectAll}
            className={`flex items-center gap-2 rounded-md px-2 py-2 text-left text-sm transition-colors ${
              selectedLeague?.id === 0
                ? "bg-[var(--theme-primary)] text-white"
                : "bg-[var(--theme-bg-muted)] text-[var(--theme-text)] hover:bg-[var(--theme-border)]"
            }`}
          >
            <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-[var(--theme-border)] text-xs">
              All
            </span>
            <span className="line-clamp-1">Tất cả</span>
          </button>

          {hotLeagues.map((league) => (
            <button
              key={league.id}
              type="button"
              onClick={() => selectLeague(league)}
              className={`flex items-center gap-2 rounded-md px-2 py-2 text-left text-sm transition-colors ${
                selectedLeague?.id === league.id
                  ? "bg-[var(--theme-primary)] text-white"
                  : "bg-[var(--theme-bg-muted)] text-[var(--theme-text)] hover:bg-[var(--theme-border)]"
              }`}
              title={league.name}
            >
              {league.logo ? (
                <img
                  src={league.logo}
                  alt={league.name}
                  className="h-7 w-7 rounded-full bg-white object-contain p-1"
                />
              ) : (
                <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-[var(--theme-border)] text-xs">
                  {league.name?.slice(0, 2) || "LG"}
                </span>
              )}
              <span className="line-clamp-1">{league.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default HotLeaguesPanel;
